module.exports = __webpack_public_path__ + "img/walk_in_the_city.f238b012.svg";